import { useEffect, useState } from "react";
import api from "@/lib/api";
import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";

export default function NotableBullsPage() {
  const [bulls, setBulls] = useState([]);
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "The Bulls — Bulls of the Big Sky";
    api.get("/notable-bulls").then((r) => setBulls(r.data)).catch(() => {});
    api.get("/site-settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="notable-bulls-page" className="min-h-screen" style={{ background: "var(--bg-primary)" }}>
      <SiteHeader />
      <section className="pt-40 pb-12 px-6 md:px-12">
        <div className="max-w-[1400px] mx-auto">
          <div className="eyebrow">The Bulls</div>
          <h1 className="font-display text-6xl md:text-8xl lg:text-9xl mt-4 leading-[0.95]">
            Sold here.<br />Proven everywhere.
          </h1>
          <p className="mt-8 max-w-3xl text-base md:text-lg" style={{ color: "var(--text-secondary)" }}>
            Bulls sold through Bulls of the Big Sky have gone on to work in AI studs, leading seedstock
            programs and commercial herds across the country. Here are a few of the bulls that have
            helped build that track record.
          </p>
        </div>
      </section>

      <section className="px-6 md:px-12 pb-24">
        <div className="max-w-[1400px] mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
          {bulls.map((b) => (
            <article
              key={b.id}
              data-testid={`notable-bull-${b.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="border flex flex-col"
              style={{ borderColor: "var(--border-subtle)", background: "var(--surface)" }}
            >
              <div className="relative overflow-hidden">
                <img
                  src={b.photo_url}
                  alt={b.name}
                  loading="lazy"
                  className="w-full aspect-[16/10] object-cover transition-transform duration-500 hover:scale-[1.04]"
                />
                {b.year_sold && (
                  <div
                    className="absolute top-4 left-4 px-3 py-1.5 text-xs font-bold tracking-widest"
                    style={{ background: "var(--brass-deep)", color: "var(--hay)", fontFamily: "'Big Shoulders Display', sans-serif", letterSpacing: "0.15em" }}
                  >
                    SOLD {b.year_sold}
                  </div>
                )}
              </div>
              <div className="p-6 md:p-8 flex flex-col flex-1">
                <h2 className="font-display text-3xl md:text-4xl leading-tight">{b.name}</h2>
                <div className="mt-2 text-sm" style={{ color: "var(--text-secondary)" }}>
                  {b.breed}  •  ASA #{b.registration}  •  Bred by {b.bred_by}
                </div>
                <div className="mt-4 text-base font-semibold" style={{ color: "var(--brass-deep)" }}>
                  {b.sold_to}
                </div>
                <p className="mt-4 text-base leading-relaxed" style={{ color: "var(--text-secondary)" }}>
                  {b.description}
                </p>
              </div>
            </article>
          ))}
        </div>
      </section>

      <SiteFooter settings={settings} />
    </div>
  );
}
